<template>
  <v-dialog v-model="resetPasswordDialog" max-width="400">
    <v-card>
      <v-card-title>Change password</v-card-title>
      <v-card-text>
        <p>
          Please click the button below to send an email that will contain the
          link for you to reset your password.
        </p>
        <v-btn
          :loading="loading"
          :disabled="sent"
          @click="sendEmail"
          color="primary"
          >Send email</v-btn
        >
        <p class="success--text text-center mt-3" v-if="sent">
          Email sent. Please check your inbox.
        </p>
        <p class="error--text text-center mt-3" v-if="error">
          There was an error processing your request. Please try again later.
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from "@/firebase";
const functions = firebase.functions("europe-west2");
const sendResetPassEmail = functions.httpsCallable("emails-sendResetPassEmail");

export default {
  data: () => ({
    loading: false,
    sent: false,
    error: false
  }),
  computed: {
    resetPasswordDialog: {
      get: function() {
        return this.$store.state.resetPasswordDialog;
      },
      set: function(value) {
        this.$store.state.resetPasswordDialog = value;
      }
    }
  },
  methods: {
    async sendEmail() {
      this.loading = true;

      try {
        await sendResetPassEmail();
        this.sent = true;
      } catch (e) {
        this.error = true;
      }

      this.loading = false;
    }
  }
};
</script>
